export default {
    init() {

        this.notice = $('.woocommerce-notices-wrapper')

        if (this.notice.length) {
            $(window).on('load', () => {
                this.hideNotices();
              });
        }

    },
    hideNotices() {

        setTimeout( () => {
            this.notice.addClass('hide-notice')
        }, 5000)

    },
};
